export default function userName(user) {

    let name = ''

    if(user.lastName)   name += user.lastName + ' '
    if(user.name)       name += user.name + ' '
    if(user.surname)    name += user.surname

    if(!name.length) return false

    return name
}